import * as Blockly from "blockly";

export interface VariableActionRequest {
  mode: "rename" | "delete";
  workspace: Blockly.Workspace;
  variableId: string;
}

const actionHandlers = new WeakMap<
  Blockly.Workspace,
  (request: VariableActionRequest) => void
>();

export function registerVariableActionHandler(
  workspace: Blockly.Workspace,
  handler: (request: VariableActionRequest) => void,
): () => void {
  actionHandlers.set(workspace, handler);
  return () => actionHandlers.delete(workspace);
}

export class FieldVariableActionsBase extends Blockly.FieldVariable {
  public override getOptions(useCache?: boolean): Blockly.MenuOption[] {
    return this.getVariableOptionsIncludingActions(useCache).filter((option) =>
      option === Blockly.FieldDropdown.SEPARATOR ||
      (option[1] !== Blockly.RENAME_VARIABLE_ID &&
        option[1] !== Blockly.DELETE_VARIABLE_ID)
    );
  }

  protected getVariableOptionsIncludingActions(
    useCache?: boolean,
  ): Blockly.MenuOption[] {
    return super.getOptions(useCache);
  }

  protected requestVariableAction(mode: "rename" | "delete"): void {
    const variable = this.getVariable();
    if (!variable) return;
    const workspace = variable.getWorkspace();
    actionHandlers.get(workspace)?.({
      mode,
      workspace,
      variableId: variable.getId(),
    });
  }
}
